import React, { useEffect, useState } from "react";
import "./AthleteEvents.css";
import "../layout/Spinner.css";
import EventModal from "../layout/EventModal";
let displayEvents = null;
const AthleteEvents = (props) => {
  const [open, setOpen] = useState(false);
  const [properties, setProperties] = useState(null);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (props.events && props.events.length > 0 && open) {
      props.events.forEach((event) => {
        if (event.eventId === id) {
          setProperties(event);
        }
      });
    }
  }, [props.events, open, id]);

  if (props.events.length > 0) {
    displayEvents = (
      <>
        <div className="AthleteEventsInfoWrapperContainer">
          <div className="AthleteEventsInfoContainer">
            <div className="AthleteEventsGroupContainer">
              <h3>Events</h3>
              {props.events &&
                props.events.map((event) => {
                  return (
                    <>
                      <div className="EventRow single" key="eventOne">
                        <div className="EventDetailsContainer">
                          <div className="EventDetails">
                            <h5
                              onClick={() => {
                                setId(event.eventId);
                                setOpen(true);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {event.eventName}
                            </h5>
                            <h4 className="date-text">
                              <span>
                                {typeof event.eventStartDate !== "string"
                                  ? event.eventStartDate
                                      .toDate()
                                      .toDateString() !==
                                    event.eventEndDate.toDate().toDateString()
                                    ? "From: "
                                    : "Date: "
                                  : event.eventStartDate !== event.eventEndDate
                                  ? "From: "
                                  : "Date: "}
                              </span>{" "}
                              {typeof event.eventStartDate !== "string"
                                ? event.eventStartDate.toDate().toDateString()
                                : event.eventStartDate}
                              {"   "}
                            </h4>
                            {typeof event.eventStartDate !== "string"
                              ? event.eventStartDate.toDate().toDateString() !==
                                  event.eventEndDate
                                    .toDate()
                                    .toDateString() && (
                                  <h4 className="date-text mb10">
                                    <span>{"   "}To:</span>{" "}
                                    {typeof event.eventEndDate !== "string"
                                      ? event.eventEndDate
                                          .toDate()
                                          .toDateString()
                                      : event.eventEndDate}
                                  </h4>
                                )
                              : event.eventStartDate !== event.eventEndDate && (
                                  <h4 className="date-text mb10">
                                    <span>{"   "}To:</span>{" "}
                                    {typeof event.eventEndDate !== "string"
                                      ? event.eventEndDate
                                          .toDate()
                                          .toDateString()
                                      : event.eventEndDate}
                                  </h4>
                                )}
                            {event.eventUrl && (
                              <a href={event.eventUrl}>{event.eventUrl}</a>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
        </div>
        {properties && (
          <EventModal
            event={properties}
            open={() => setOpen(true)}
            close={() => setOpen(false)}
            hidden={open}
          />
        )}
      </>
    );
  } else {
    displayEvents = null;
  }

  return displayEvents;
};

export default AthleteEvents;
